import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexShrink: 0,
    },
    icon: {
      fill: "#2B3940",
      transform: "scale(1.4)",
    },
  })
);
